import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetSlotByIdQuery } from "../../slots.service";
import { SlotDetails } from "../../components/slot-details";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

const SlotDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToSlots = appendSearchToPath("/slots", location.search);
  const { data: slot, isLoading, isError, error } = useGetSlotByIdQuery(id || "");

  if (isLoading) return <div className="p-6">Loading...</div>;
  if (isError || !slot) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
            <h2 className="text-2xl font-bold text-red-800 mb-4">Slot Not Found</h2>
            <p className="text-red-600 mb-6">{typeof error === "object" && error ? "Could not load slot" : ""}</p>
            <button onClick={() => navigate(backToSlots)} className="px-6 py-3 bg-red-600 text-white rounded-lg">
              Back to Slots
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <SlotDetails slot={slot} onBack={() => navigate(backToSlots)} />;
};

export default SlotDetailsPage;

